query contentAnalyticsViewedComments(
  $contentId: ID!
  $contentType: ConfluenceAnalyticsCommentContentType
) {
  contentAnalyticsViewedComments(contentId: $contentId, contentType: $contentType) {
    commentIds
  }
}
